import { useEffect, useRef } from 'react';

type Props = {
  scrollKey?: unknown;
};

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Keeps the latest message in view: inside the panel when it scrolls, in the page on phones. */
export function useChatPanel(props: Props) {
  const endRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    endRef.current?.scrollIntoView?.({
      block: 'end',
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  }, [props.scrollKey]);

  return { endRef };
}
